import { Formik, FormikErrors } from 'formik';

import { AddressMessage } from '../../../../../types/AddressMessage';
import { translate } from '../../../../common/helpers/translate.helper';

import { FormikCustomerCreateForm } from './FormikCustomerCreateForm';

export interface FormikCustomerCreateState {
    name: string;
    internalName?: string;
    email: string;
    phone?: string;
    fax?: string;
    invoiceMail: string;
    address: AddressMessage;
    spotAllowed: boolean;
    testCompany: boolean;
    trial: boolean;
}

export interface CreateCustomerCompanyFormProps {
    onSubmit: (values: FormikCustomerCreateState) => Promise<void>;
}

export const CreateCustomerCompanyForm = ({ onSubmit }: CreateCustomerCompanyFormProps) => {
    const initialFormikState: FormikCustomerCreateState = {
        name: '',
        internalName: '',
        email: '',
        phone: '',
        fax: '',
        invoiceMail: '',
        address: {
            city: '',
            companyName: '',
            country: '',
            street: '',
            streetNumber: '',
            zipcode: '',
        },
        testCompany: true,
        spotAllowed: false,
        trial: false,
    };

    const validate = (values: FormikCustomerCreateState) => {
        const errors: FormikErrors<FormikCustomerCreateState> = {};

        if (!values.name) {
            errors.name = translate('customer.noCompanyNameError');
        }

        if (!values.email) {
            errors.email = translate('customer.noEmailError');
        }

        return errors;
    };

    return (
        <Formik
            initialValues={initialFormikState}
            onSubmit={onSubmit}
            validate={validate}
            component={FormikCustomerCreateForm}
        />
    );
};
